// Shimmer placeholder for a Business Admin list tab (title, search box and table) shown while a
// tab's data is being fetched. Mirrors the list section layout so content swaps in without shifting.
function ShimmerBar({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <div className={`relative overflow-hidden rounded bg-neutral-100 ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/70 to-transparent" />
    </div>
  );
}

const ROW_IDS = ['r1', 'r2', 'r3', 'r4', 'r5', 'r6'];
const NAME_WIDTHS = ['w-40', 'w-32', 'w-48', 'w-36', 'w-44', 'w-28'];

export default function TabContentSkeleton() {
  return (
    <section
      className="flex-1 rounded-lg bg-white"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="mx-6 flex items-start justify-between gap-4 border-b border-neutral-200 py-5">
        <div className="space-y-2">
          <ShimmerBar className="h-4 w-48" />
          <ShimmerBar className="h-3 w-72" />
        </div>
        <ShimmerBar className="h-9 w-32 rounded-md" />
      </div>
      <div className="my-7">
        <div className="px-6 pb-4">
          <ShimmerBar className="h-9 w-full rounded-md" />
        </div>
        <div className="px-6 pb-8">
          <div className="overflow-hidden rounded-lg border border-neutral-200">
            <div className="flex gap-10 border-b border-neutral-200 bg-neutral-50 px-6 py-3.5">
              <ShimmerBar className="h-3 w-24" />
              <ShimmerBar className="h-3 w-20" />
              <ShimmerBar className="h-3 w-28" />
              <ShimmerBar className="h-3 w-20" />
            </div>
            {ROW_IDS.map((id, i) => (
              <div
                key={id}
                className="flex items-center gap-10 border-b border-neutral-100 px-6 py-4 last:border-b-0"
              >
                <ShimmerBar className={`h-4 ${NAME_WIDTHS[i]}`} />
                <ShimmerBar className="h-4 w-24" />
                <ShimmerBar className="h-5 w-28 rounded-md" />
                <ShimmerBar className="h-7 w-28 rounded-md" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
